import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../services/supabaseClient'
import { useAuth } from '../context/AuthContext'

export default function Schedule() {
  const { user, signOut } = useAuth()
  const email = user?.email || ''
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [periods, setPeriods] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    let active = true
    ;(async () => {
      setLoading(true)
      setError('')
      const { data, error: rpcError } = await supabase.rpc('get_student_today_schedule')
      if (!active) return
      if (rpcError) {
        setError(rpcError.message || 'حدث خطأ أثناء تحميل جدول اليوم')
        setPeriods([])
      } else {
        setPeriods(data || [])
      }
      setLoading(false)
    })()
    return () => { active = false }
  }, [])

  function formatTime(t) {
    if (!t) return ''
    return String(t).slice(0, 5)
  }

  const todayLabel = new Date().toLocaleDateString('ar-EG', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <div
      dir="rtl"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        padding: '1.5rem',
      }}
    >
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div
          style={{
            backgroundColor: '#ffffff',
            borderRadius: 16,
            padding: 16,
            boxShadow: '0 10px 25px rgba(15,23,42,0.08)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1 style={{ margin: 0 }}>جدول اليوم</h1>
            <button
              type="button"
              onClick={signOut}
              style={{
                padding: '6px 10px',
                borderRadius: 999,
                border: '1px solid #e5e7eb',
                background: '#f9fafb',
                cursor: 'pointer',
                fontSize: 13,
              }}
            >
              تسجيل الخروج
            </button>
          </div>

          <div style={{ color: '#6b7280', marginTop: 4, marginBottom: 12, fontSize: 14 }}>
            {todayLabel}
          </div>

          {email && (
            <p style={{ marginBottom: 8 }}>تم تسجيل الدخول بالبريد: <strong>{email}</strong></p>
          )}

          {loading && (
            <div style={{ textAlign: 'center', marginTop: 24 }}>جاري تحميل جدول اليوم...</div>
          )}

          {!loading && error && (
            <div style={{ color: '#b91c1c', marginTop: 16 }}>{error}</div>
          )}

          {!loading && !error && periods.length === 0 && (
            <div style={{ marginTop: 16 }}>لا يوجد حصص مجدولة لليوم.</div>
          )}

          {!loading && !error && periods.length > 0 && (
            <ul style={{ listStyle: 'none', padding: 0, marginTop: 16 }}>
              {periods.map((p) => (
                <li
                  key={`${p.day_of_week}-${p.period_number}-${p.subject_id || ''}-${p.start_time}`}
                  style={{
                    border: '1px solid #e5e7eb',
                    borderRadius: 8,
                    padding: 12,
                    marginBottom: 8,
                    background: '#fff',
                  }}
                >
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>
                    {formatTime(p.start_time)} - {formatTime(p.end_time)}
                  </div>
                  <div style={{ marginBottom: 2 }}>
                    المادة: <strong>{p.subject_name || 'غير محددة'}</strong>
                  </div>
                  <div style={{ marginBottom: 2 }}>
                    المعلم: <strong>{p.teacher_name || 'غير محدد'}</strong>
                  </div>
                  <div>
                    الغرفة: <strong>{p.room || 'غير محددة'}</strong>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}
